/* eslint-disable */
import requestRaw from '@/utils/requestRaw'
import requestDev from '@/utils/requestDev'

import {  APICoreV2, APIReportPHP } from '@/utils/servicesApi'
const qs = require('qs')
export function listData(params) {
  return requestDev({
      url: APIReportPHP() + '/gmap/list-data',
      method: 'POST',
      data: qs.stringify(params)
  })
}

export function downloadExcelContact(params) {
  return requestDev({
    url: APIReportPHP() + '/gmap/download-excel-contact',
    method: 'POST',
    data: qs.stringify(params)

  })
}
export function downloadExcelBc(params) {
  return requestDev({
    url: APIReportPHP() + '/gmap/download-excel-bc',
    method: 'POST',
    data: qs.stringify(params)
  })
}
export function headerList(data) {
  return requestRaw({
    url: APICoreV2() + '/gmap/header-list',
    method: 'POST',
    data: data // untuk array data post
  })
}

export function createHeader(data) {
  return requestRaw({
    url: APICoreV2() + '/gmap/create-header',
    method: 'POST',
    data: data, // untuk array data post
    silent: true
  })
}

export function setupKey(data) {
  return requestRaw({
    url: APICoreV2() + '/gmap/setup',
    method: 'POST',
    data: data, // untuk array data post
    silent: true
  })
}

export function getGmapKey() {
  return requestRaw({
    url: APICoreV2() + '/gmap/key',
    method: 'GET',
    silent: true
  })
}


// WEBPACK FOOTER //
// ./src/api/gmapKey.js